import { profileApi } from './../../config/api-url';
import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { sellerApi } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private apiService: ApiService) { }

  getStandardIncentives(params) {
    return this.apiService.get(`${sellerApi.getStandardIncentives}`, params);
  }

  getBonusIncentives(params) {
    return this.apiService.get(`${sellerApi.getBonusIncentives}`, params);
  }

  salesDealsToClaimed(companyId, params) {
    const url = sellerApi.salesDealsToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  activityDealsToClaimed(companyId, params) {
    const url = sellerApi.activityDealsToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  claimedDeals(params) {
    return this.apiService.get(`${sellerApi.claimedDeals}`, params);
  }

  pendingClaimedDeals(params) {
    return this.apiService.get(`${sellerApi.pendingClaimedDeals}`, params);
  }

  claimDeal(claimId) {
    return this.apiService.get(`${sellerApi.claimDeal}${claimId}`);
  }

  getPointsAvailable() {
    return this.apiService.get(`${sellerApi.getPointsAvailable}`);
  }

  getCreditsAvailable() {
    return this.apiService.get(`${sellerApi.getCreditsAvailable}`);
  }

  getPointsGrsUrlForUser(pamData?:any) {
    if(pamData==undefined){
      pamData='';
    }
    return this.apiService.get(`${sellerApi.getPointsGrsUrlForUser}${pamData}`);
  }

  getCreditsGrsUrlForUser() {
    return this.apiService.get(`${sellerApi.getCreditsGrsUrlForUser}`);
  }

  getPrescribedEnablementsSeller(params) {
    return this.apiService.get(`${sellerApi.getPrescribedEnablementsSeller}`, params);
  }

  getSaleChallengesSeller(params) {
    return this.apiService.get(`${sellerApi.getSaleChallengesSeller}`, params);
  }

  claimDealByPo(params) {
    return this.apiService.post(`${sellerApi.claimDealByPo}`, params);
  }

  getCoursesTakeClass() {
    return this.apiService.get(`${sellerApi.coursesTakeClass}`);
  }

  deleteChallenge(challengeId) {
    return this.apiService.delete(`${sellerApi.deleteChallenge}/${challengeId}`);
  }

  getOtherChallengeDeals(companyId, params) {
    return this.apiService.get(`${sellerApi.getOtherChallengeDeals}/${companyId}/activationChallengeDeals`, params);
  }

  getOtherChallengeCount(params) {
    return this.apiService.get(`${sellerApi.getOtherChallengeCount}`, params);
  }
  centerDealsToClaimed(companyId, params) {
    const url = sellerApi.centerDealsToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  nexuscenterDealsToClaimed(companyId, params) {
    const url = sellerApi.nexuscenterDealsToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  blackBeltDealsToClaimed(companyId, params) {
    const url = sellerApi.blackBeltDealsToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  blackBeltIOTDealsToClaimed(companyId, params) {
    const url = sellerApi.blackBeltIOTDealsToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  getPointTransaction(body) {
    return this.apiService.get(`${sellerApi.pointTransactionHistory}`, body);
  }

  getTicketTransaction(body) {
    return this.apiService.get(`${sellerApi.ticketTransactionHistory}`, body);
  }

  securitySpringDealToClaimed(companyId, params) {
    const url = sellerApi.securitySpringDealToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  collaborationSprintDealToClaimed(companyId, params) {
    const url = sellerApi.collaborationSprintDealToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  cloudCallingToClaimed(companyId, params) {
    const url = sellerApi.cloudCallingToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  getTicketRedemption(params) {
    return this.apiService.get(`${sellerApi.getTicketRedemption}?userId=${params.userId}`);
  }

  redeemTicketCatalog(params) {
    return this.apiService.post(`${sellerApi.redeemTicketCatalog}?userId=${params.userId}&catalogItemId=${params.catalogItemId}`);
  }

  merakiToClaimed(companyId, params) {
    const url = sellerApi.merakiToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  dnaToClaimed(companyId, params) {
    const url = sellerApi.dnaToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  wanToClaimed(companyId, params) {
    const url = sellerApi.wanToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  } 

  saseToClaimed(companyId, params) {
    const url = sellerApi.saseToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  } 

  ibnToClaimed(companyId, params) {
    const url = sellerApi.ibnToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  } 

  eaToClaimed(companyId, params) {
    const url = sellerApi.eaToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  } 

  officeToClaimed(companyId, params) {
    const url = sellerApi.officeToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  } 

  iotsalesToClaimed(companyId, params) {
    const url = sellerApi.iotsalesToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }

  collabToClaimed(companyId, params) {
    const url = sellerApi.collabToClaimed.replace('{companyId}', companyId);
    return this.apiService.get(`${url}`, params);
  }
  uploadAttachedDocument(filedata,param){
    return this.apiService.postForFile(`${profileApi.uploadAttachedDocument}${param}`, filedata);
  }

  getNewSalesChallengeList(companyId, optionalParams?) {
    return this.apiService.get(`${sellerApi.newSalesChallenge}/${companyId}?${optionalParams}`);
  }

  getChallengeDetails(dealId) {
    return this.apiService.get(`${sellerApi.challengeDetails}/${dealId}`);
  }

  resendApprovalLink(req){
    return this.apiService.post(`${sellerApi.resendApprovalLink}${req}`);
  }
  claimByPoSeller(params){
    return this.apiService.post(`${sellerApi.claimByPoSeller}${params}`, );
  }
  getsellerPointActivityData(params){
    return this.apiService.get(
      `${sellerApi.pointActivitySeller}${params}`,
    ); 
  }
  getSalesChallengeData(params){
    return this.apiService.get(
      `${sellerApi.salesChallengePerformence}${params}`,
    );
  }
  getLeaderTicketActivityData(params){
    return this.apiService.get(
      `${sellerApi.ticketActivity}${params}`,
    );
  }
  getClaimedData(params){
    return this.apiService.get(
      `${sellerApi.claimStatusSummary}${params}`,
    );
  }
  getStatisticsData(params){
    return this.apiService.get(
      `${sellerApi.statisticsData}${params}`,
    );
  }
  getDistributedPointActivity(params){
    return this.apiService.get(
      `${sellerApi.distributedPointActivity}${params}`,
    );
  }
  getSalesActivityData(params){
    return this.apiService.get(
      `${sellerApi.salesActivityData}${params}`,
    );
  }
  uploadActivityChallengeDocuments(filedata, params) {
    return this.apiService.postForFile(
      `${sellerApi.uploadActivityChallengeDocuments}${params}`, filedata
    )
  }
  uploadCompletion(fileData,params){
    return this.apiService.postForFile(
      `${sellerApi.uploadCompletion}${params}`, fileData
    )
  }
  getCashEarnedData(){
    return this.apiService.get(
      `${sellerApi.cashBreakdown}`,
    );
  }
  getpointsExpiryTrackerData(){
        return this.apiService.get(
      `${sellerApi.pointsExpiryTracker}`,
    );
  }
}
